export default __webpack_public_path__ + "static/media/rightBgPicture.6bf18282.png";